module.exports = __webpack_public_path__ + "static/media/cheap-o-air.4df2e157.jpg";